import { Box, Typography } from "@mui/material";
import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const StatBox = ({ title, subtitle, icon, chartData, dataKey, Color }) => {
  return (
    <Box width="100%" m="0 30px">
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" flexDirection="column">
          <Box mt={"1.2vw"}>{icon}</Box>
          <Box mt={"1.7vw"}>
            <Typography variant="h5" fontWeight="bold" color="var(--white)">
              {title}
            </Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="space-around"
          flexDirection="column"
          width="35%"
        >
          <ResponsiveContainer width="80%" aspect={1.5}>
            <LineChart data={chartData}>
              <Tooltip
                contentStyle={{ background: "transparent", border: "none" }}
                labelStyle={{ display: "none" }}
                position={{ x: 10, y: 30 }}
              />
              <Line
                type="monotone"
                dataKey={dataKey}
                stroke={Color}
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
          <Typography variant="h6" sx={{ color: "var(--white)", ml: "2vw" }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StatBox;
